// extracted by mini-css-extract-plugin
export default {"contentWrapper":"style--contentWrapper--62896c","label":"style--label--9fe651"};